import { Box, BoxProps } from '@chakra-ui/react';
import { WidgetOptions, createWidget } from '@typeform/embed';
import * as React from 'react';
import { useEffect, useRef } from 'react';

export interface SessionSurveyProps extends BoxProps {
  id: string;
  formProps?: Omit<WidgetOptions, 'container'>;
  hiddenSurveyProps: Record<string, string>;
}

const SessionSurvey = ({
  id,
  formProps,
  hiddenSurveyProps,
  ...rest
}: SessionSurveyProps): React.ReactElement | null => {
  const surveyRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!surveyRef.current) return;
    createWidget(id, {
      container: surveyRef.current,
      hideFooter: true,
      hideHeaders: true,
      opacity: 0.5,
      hidden: hiddenSurveyProps,
      ...formProps,
    });
  }, [formProps, id, hiddenSurveyProps]);

  return (
    <Box {...rest}>
      <Box
        ref={surveyRef}
        w="100%"
        h="100%"
        css={{
          '>*, .typeform-widget, iframe': { width: '100%', height: '100%' },
        }}
      />
    </Box>
  );
};
export default SessionSurvey;
